export default __webpack_public_path__ + "static/media/touch.f1205d44.svg";